import { services } from "@/data/services";
import { useEnquiry } from "@/context/EnquiryContext";
import { Section } from "./Section";
import { Reveal, ImageReveal } from "./Reveal";
import { ArrowRight } from "lucide-react";

const Row = ({ label, text, accent = false }) => (
    <div className="mt-4">
        <p
            className={`font-display text-[9px] uppercase tracking-[0.25em] ${
                accent ? "text-rz-red" : "text-rz-smoke"
            }`}
        >
            {label}
        </p>
        <p className="mt-1.5 text-[13px] leading-relaxed text-rz-smoke">{text}</p>
    </div>
);

const ServiceBlock = ({ s, i }) => {
    const { setService } = useEnquiry();
    return (
        <Reveal delay={(i % 2) * 0.08} className={i % 2 === 1 ? "lg:mt-20" : ""}>
            <article
                data-testid={`service-card-${s.id}`}
                className="rz-corners group border border-rz-steel/60 bg-rz-graphite/40 transition-colors duration-500 hover:border-rz-steel hover:bg-rz-graphite/70"
            >
                <div className="relative overflow-hidden">
                    <ImageReveal>
                        <img
                            src={s.image}
                            alt={s.alt}
                            loading="lazy"
                            decoding="async"
                            className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                        />
                    </ImageReveal>
                    <div className="absolute inset-0 bg-gradient-to-t from-rz-graphite via-transparent to-transparent" />
                    <span className="absolute left-5 top-5 font-display text-[11px] uppercase tracking-[0.25em] text-rz-red">
                        {String(i + 1).padStart(2, "0")}
                    </span>
                </div>
                <div className="relative p-6 sm:p-8">
                    <span className="absolute left-0 top-0 h-px w-0 bg-rz-red transition-[width] duration-500 group-hover:w-full" />
                    <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-rz-white sm:text-3xl">
                        {s.name}
                    </h3>
                    <Row label="Problem" text={s.problem} />
                    <Row label="Solution" text={s.solution} />
                    <Row label="Result" text={s.result} accent />
                    <a
                        href="#contact"
                        data-testid={`service-enquire-${s.id}`}
                        onClick={() => setService(s.name)}
                        className="mt-6 inline-flex items-center gap-2 font-display text-[12px] font-semibold uppercase tracking-[0.2em] text-rz-red transition-[transform,color] duration-300 hover:translate-x-1"
                    >
                        Enquire about {s.name} <ArrowRight size={14} />
                    </a>
                </div>
            </article>
        </Reveal>
    );
};

export const Services = () => (
    <Section id="services" index="06" label="Services" title="Built around your vehicle." alt>
        <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:gap-10">
            {services.map((s, i) => (
                <ServiceBlock key={s.id} s={s} i={i} />
            ))}
        </div>
        <Reveal className="mt-10" delay={0.1}>
            <p className="max-w-[70ch] text-sm leading-relaxed text-rz-smoke">
                Beyond the six core disciplines, the studio also handles interior detailing, ozone
                treatment, window tinting, alloys and tyres, audio and light upgrades, rust
                proofing, glass coating and tuning — ask when you enquire. Every service is
                available at our Colvale studio, a short drive from Mapusa, Porvorim and the rest
                of Bardez, North Goa.
            </p>
        </Reveal>
    </Section>
);
